module.exports = "//static.hsappstatic.net/settings-ui-security/static-1.12569/images/email.svg"